import { Navigate } from '@tanstack/react-router';
import { Spin, Tag, Typography } from 'antd';
import { useAuth } from '@/features/auth/auth-context';
import { useActiveOrg } from '@/features/organizations/active-org-context';
import { HealthPanel } from '@/features/health/ui/HealthPanel';

export function DashboardPage() {
  const { user } = useAuth();
  const { organizations, activeOrg, isLoading } = useActiveOrg();

  if (isLoading) return <Spin />;
  // First-run: no organizations yet → send the user to create one.
  if (organizations.length === 0) return <Navigate to="/organizations/new" />;

  return (
    <>
      <Typography.Title level={3} style={{ marginBottom: 0 }}>
        Welcome{user ? `, ${user.name}` : ''}
      </Typography.Title>
      <Typography.Paragraph type="secondary">
        {activeOrg ? (
          <>
            Active organization: <strong>{activeOrg.name}</strong>{' '}
            <Tag color={activeOrg.role === 'owner' ? 'gold' : 'blue'}>{activeOrg.role}</Tag>
          </>
        ) : (
          'Select an organization to get started.'
        )}
      </Typography.Paragraph>
      <Typography.Paragraph type="secondary">
        Projects, brand settings, and agents arrive in the next phases.
      </Typography.Paragraph>
      <HealthPanel />
    </>
  );
}
